import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { vaccineConfig } from '../config/vaccineConfig';
import { VaccineService } from '../../../../shared/services/vaccineService';

/**
 * VaccineDetail - URL-based detail page for Vaccines
 * Handles view, edit, and add modes with ID from URL params
 */
export default function VaccineDetail() {
  return (
    <CRUDDetailPage
      config={vaccineConfig}
      service={VaccineService}
    />
  );
}
